export const OPEN_FAN_KEY = 'job-result-send-off';

export const TYPE_APPLICANT = 'applicant';
export const TYPE_CUSTOMER = 'customer';

const store = {
	namespaced: true,
	state: {
		show: false,
		type: undefined,
		message: undefined,
		appointment: undefined,
		applicantData: undefined,
		customerData: undefined,
		onClose: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setType', data.type);
			commit('setAppointment', data.appointment);
			commit('setMessage', data.message);
			commit('setApplicantData', data.applicantData);
			commit('setCustomerData', data.customerData);
			commit('setOnClose', data.onClose);

			commit('setShow', true);
		},
		close ({commit, state}, data)
		{
			if (state.onClose)
			{
				state.onClose({
					sentOff: data.sentOff
				});
			}

			commit('setShow', false);

			commit('setType', undefined);
			commit('setAppointment', undefined);
			commit('setMessage', undefined);
			commit('setApplicantData', undefined);
			commit('setCustomerData', undefined);
			commit('setOnClose', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setType: (state, value) => state.type = value,
		setAppointment: (state, value) => state.appointment = value,
		setMessage: (state, value) => state.message = value,
		setApplicantData: (state, value) => state.applicantData = value,
		setCustomerData: (state, value) => state.customerData = value,
		setOnClose: (state, value) => state.onClose = value,
	},
};

export default store;
